import Marquee from "react-fast-marquee";

const PLACES = ["Lake Asbury", "Middleburg", "Oakleaf", "Fleming Island", "Orange Park", "Green Cove Springs", "Lakeside", "Keystone Heights", "Doctors Inlet", "Greater Clay County"];

export default function LocationMarquee() {
  return (
    <div className="border-y border-white/10 bg-navy py-5" aria-hidden="true">
      <Marquee speed={35} gradient={false} pauseOnHover>
        {PLACES.concat(PLACES).map((p, i) => (
          <span key={i} className="mx-6 flex items-center gap-6 font-display text-sm font-700 uppercase tracking-[0.3em] text-white/70">
            {p}
            <span className="h-1.5 w-1.5 rounded-full bg-victory" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
